/** @format */

import clsx from 'clsx'
import React, {type PropsWithChildren} from 'react'

import {OpenModalLink} from '@src/components/tailwind/ModalContext'

import {ColumnConfigModal} from './ColumnConfigModal'
import {ExportModal} from './ExportModal'
import {useSubmissionsContext} from './SubmissionsContext'

export function Menubar() {
  return (
    <div className="flex items-center border-b border-gray-100 p-2 sm:p-3">
      <FiltersGroup />
      <ActionsGroup />
    </div>
  )
}

function FiltersGroup() {
  const {filter, overlimitCount, setFilter, spamCount, setSearch} =
    useSubmissionsContext()
  return (
    <div className="flex gap-x-1">
      <Filter
        isActive={filter.folder === 'inbox'}
        onClick={() => {
          setFilter({folder: 'inbox'})
          setSearch('')
        }}
      >
        Inbox
      </Filter>
      <Filter
        isActive={filter.folder === 'spam'}
        onClick={() => {
          setFilter({folder: 'spam'})
          setSearch('')
        }}
      >
        Spam ({spamCount})
      </Filter>
      {(overlimitCount > 0 || filter.folder === 'overlimit') && (
        <Filter
          isActive={filter.folder === 'overlimit'}
          onClick={() => {
            setFilter({folder: 'overlimit'})
            setSearch('')
          }}
        >
          Over Limit ({overlimitCount})
        </Filter>
      )}
    </div>
  )
}

type FilterProps = PropsWithChildren<{
  isActive: boolean
  onClick: () => void
}>

function Filter(props: FilterProps) {
  const {children, isActive, onClick} = props
  return (
    <button
      className={clsx(
        'block cursor-pointer rounded px-2 py-1 text-xs font-medium text-gray-500',
        isActive && 'bg-gray-100 text-gray-900',
      )}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  )
}

const COLUMN_CONFIG_MODAL = 'form.submissions_v2.display-config'
const EXPORT_MODAL = 'form.submissions_v2.export'

function ActionsGroup() {
  const {data, search, filter} = useSubmissionsContext()

  const searchResultsCount = data?.submissions.length ?? 0

  return (
    <div className="ms-auto flex items-center gap-x-4">
      <ColumnConfigModal modal={COLUMN_CONFIG_MODAL} />
      <OpenModalLink
        modal={COLUMN_CONFIG_MODAL}
        className="primaryLink cursor-pointer text-sm"
      >
        Settings
      </OpenModalLink>
      {/* over-limit submissions can't be exported — move them to the inbox first */}
      {data && data.submissions.length > 0 && filter.folder !== 'overlimit' && (
        <>
          <ExportModal
            modal={EXPORT_MODAL}
            selectedIds={[]} // No selection from menubar
            searchQuery={search}
            searchResultsCount={searchResultsCount}
            currentFolder={filter.folder === 'spam' ? 'spam' : 'inbox'}
          />
          <OpenModalLink
            className="primaryLink cursor-pointer text-sm"
            modal={EXPORT_MODAL}
          >
            Export
          </OpenModalLink>
        </>
      )}
    </div>
  )
}
